/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as HERBUI from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import Header from "./Header";
import * as Yup from 'yup';
import Footer from "./Footer";
import Sweetalert, { allowNumbersOnly, formatCountdown, startOtpTimer } from "../components/Functions";
import { CommonAjaxPostLoginRequestUpdated } from "../Api/CommonAjaxUtils";
import { useDispatch } from "react-redux";
import { LOGIN_API_UPDATED } from "../Api/APIURLS";

export default function KnowYourCfmsId() {
    const dispatch = useDispatch()

    const [buttonType, setButtonType] = useState("Generate OTP");
    const [otpStatus, setOtpStatus] = useState(false);
    const [details, setDetails] = useState();
    const [showDetails, setShowDetails] = useState(false);
    const [resendTimerShow, setResendTimerShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [successMsg, setSuccessMsg] = useState("");
    const [remainingTime, setRemainingTime] = useState(0);

    const formik = useFormik({
        initialValues: {
            mobileNumber: "", otp: "",
            challengeExpiresAt: '', challengeId: ''
        },
        validationSchema: Yup.object({
            mobileNumber: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            if (buttonType === 'Generate OTP') {
                sendOTP()
            }
            else if (buttonType === 'Verify OTP') {
                verifyOTPHandler()
            }
        }
    })
    function sendOTP(values) {
        formik.setFieldValue("otp", '')
        let params = { mobileNo: formik?.values?.mobileNumber }
        // CommonAjaxGetRequestWithOutParamsWithOutAuthorization(GENERATE_OTP_URL + "/" + formik?.values?.mobileNumber, dispatch).then(res => {
        // CommonAjaxPostRequest(GENERATE_OTP_URL, params, dispatch).then(res => {
        CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/find-cfmsid/send-otp', params, dispatch).then(res => {
            if (res) {
                if (res.status === 200) {
                    let responseData = res?.data;
                    formik.setFieldValue('challengeId', responseData?.challengeId);
                    formik.setFieldValue('challengeExpiresAt', responseData?.challengeExpiresAt);
                    startOtpTimer(responseData?.challengeExpiresAt, setRemainingTime);
                    setResendTimerShow(true);
                    setOtpStatus('sent');
                    setErrorMessage("");
                    setSuccessMsg(responseData?.message);
                }
                else {
                    setErrorMessage(res?.data?.errorMessage);
                    setSuccessMsg("");
                    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                }
            }
        }).catch(() => setTimeout(() => {
            // call   
        }, 1500))
    }

    function verifyOTPHandler() {
        // let params = { mobileNo: formik?.values?.mobileNumber, otp: formik.values.otp, secureKey: formik.values.secureKey }
        let params = { "challengeId": formik.values?.challengeId, "otp": formik.values.otp }
        CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/find-cfmsid/verify-otp', params, dispatch).then(res => {
            // CommonAjaxPostRequest(VERIFY_OTP_URL, params, dispatch).then(res => {
            if (res) {
                if (res?.status === 200) {
                    setDetails(res?.data?.data[0]);
                    setShowDetails(true);
                    setErrorMessage("");
                    setSuccessMsg(res?.data?.message);
                }
                else {
                    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                    if (res?.status === 408) {
                        // setResendTimerShow(false);
                        Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                            if (isConfirm.value) {
                                window.location.href='/knowYourCfmsId'
                            }
                        })
                        return;
                    }
                    if (res?.status === 410) {
                        // setResendTimerShow(false);
                        Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                            if (isConfirm.value) {
                                window.location.href='/knowYourCfmsId'
                            }
                        })
                        return;
                    }
                    if (res?.status === 429) {
                        // setResendTimerShow(false);
                        Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                            if (isConfirm.value) {
                                window.location.href='/knowYourCfmsId'
                            }
                        })
                        return;
                    }
                    if (res?.data) {
                        setErrorMessage(res?.data?.errorMessage);
                        setSuccessMsg("");
                    }
                }
            }
        })
    }

    useEffect(() => {
        formik.setFieldValue("otp", '');
    }, [])

    return (
        <>   <Header />
            <div className="main_section"> </div>
            <HERBUI.Container style={{ marginTop: "80px" }}>
                <HERBUI.Row>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
                        <div className="inner-herbpage-service-title1">
                            <h1> Know Your CFMS ID </h1>
                        </div>
                    </HERBUI.Col>
                </HERBUI.Row>
            </HERBUI.Container>
            <HERBUI.Container className=" bg-white">
                <HERBUI.Row className="pt-5" >
                    <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                        &nbsp;
                    </HERBUI.Col>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={112} xl={12} xxl={12}>
                                        <div className='alert alert-info ps-4'>
                                            <li> <span className='mb-1'>To Change Mobile Number: Visit <b>ESS(Employee Self Services)</b></span>&nbsp;&nbsp;</li>
                                        </div>
                                    </HERBUI.Col>
                                </HERBUI.Row>
                                <br />
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2}>
                                    </HERBUI.Col>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={10} xl={8} xxl={8}>
                                        <HERBUI.InputGroup className="mb-4p5">
                                            <span className="label-text-style"> Mobile Number </span>
                                            <Field type='text' name="mobileNumber"
                                                id="mobileNumber"
                                                maxLength={10} disabled={otpStatus}
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                className={'form-control'}
                                                autoComplete="off" />
                                            <ErrorMessage className="text-error" name="mobileNumber" component="div" />
                                        </HERBUI.InputGroup>
                                    </HERBUI.Col>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2}>
                                    </HERBUI.Col>

                                    {otpStatus && !showDetails &&
                                        <>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2}>
                                            </HERBUI.Col>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={10} xl={8} xxl={8}>
                                                <HERBUI.InputGroup className="mb-4p5">
                                                    <span className="label-text-style"  ><span className="mandatory" >*</span>Enter the OTP : </span>
                                                    <Field type='text' name="otp" className="form-control mandatoryField" maxLength={6} onKeyPress={allowNumbersOnly}
                                                        placeholder="_ _ _ _ _ _" autoComplete="off" style={{ letterSpacing: '10px' }} />
                                                    <ErrorMessage className="text-error" name="otp" component="div" />
                                                </HERBUI.InputGroup>
                                                {
                                                    resendTimerShow &&
                                                    <small className="text-danger otp-time">
                                                        your OTP is expires in {formatCountdown(remainingTime)}
                                                    </small>
                                                }

                                                {/* <div className="herb-otp-all ">
                                            <div>
                                                <HERBUI.InputGroup className="mb-1">
                                                    <span className="label-text-style"  ><span className="mandatory" >*</span>Enter the OTP : </span>

                                                    <div className="herb-otp mt-1">
                                                        {otp.map((digit, index) => (
                                                            <input
                                                                key={index}
                                                                type="text"
                                                                maxLength={1}
                                                                value={digit}
                                                                ref={(el) => (inputRefs.current[index] = el)}
                                                                onChange={(e) => handleChange(e.target.value, index)}
                                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                            />
                                                        ))}
                                                    </div>
                                                    <ErrorMessage className="text-error" name="otp" component="div" />
                                                </HERBUI.InputGroup>
                                                <small className="text-danger otp-time">
                                                    your OTP is expires in {formatCountdown(remainingTime)}
                                                </small>
                                            </div>
                                            <div className="text-end mt-1">
                                                <HERBUI.Button variant="success" type="submit" className="btn_success btn-sm verify-otp">
                                                    {buttonType}
                                                </HERBUI.Button>
                                               
                                            </div>
                                        </div> */}

                                            </HERBUI.Col>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2}>
                                            </HERBUI.Col>

                                        </>
                                    }
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2} />
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                                        <span className="text-success">{successMsg}</span>
                                    </HERBUI.Col>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2} />
                                    {
                                        !showDetails &&
                                        <>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2} />
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                                                <div className="text-end mt-1">
                                                    {
                                                        otpStatus === false ?
                                                            <HERBUI.Button variant="success" type="submit" className="btn_success btn-sm verify-otp">
                                                                {buttonType}
                                                            </HERBUI.Button> :
                                                            <button type="submit" className="btn btn-success"
                                                                disabled={formik?.values?.otp?.length !== 6 || (details !== undefined && details !== "")}
                                                                onClick={() => { setButtonType("Verify OTP"); }}
                                                            >Verify-OTP</button>
                                                    }
                                                </div>
                                                {errorMessage &&
                                                    <small className="text-danger">{errorMessage}</small>}
                                            </HERBUI.Col>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={2} xxl={2} />
                                        </>
                                    }

                                </HERBUI.Row>

                                {/* {otpStatus && !showDetails &&
                                    <>
                                        <HERBUI.Row>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></HERBUI.Col>
                                            <span className="text-success">{successMsg}</span>
                                            <HERBUI.Col className="mt-4" xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                <HERBUI.InputGroup className="mb-4p5">
                                                    <span className="label-text-style"  ><span className="mandatory" >*</span>Enter the OTP : </span>
                                                    <Field type='text' name="otp" className="form-control mandatoryField" maxLength={6} onKeyPress={allowNumbersOnly}
                                                        placeholder="_ _ _ _ _ _" autoComplete="off" style={{ letterSpacing: '10px' }} />
                                                    <ErrorMessage className="text-error" name="otp" component="div" />
                                                </HERBUI.InputGroup>

                                            </HERBUI.Col>
                                            <>
                                                {
                                                    successMsg &&
                                                    <span className="text-success">
                                                        {successMsg}
                                                    </span>
                                                }
                                                {
                                                    errorMessage &&
                                                    <span className="text-success">
                                                        {errorMessage}
                                                    </span>
                                                }

                                                <small className="text-danger fw-semibold">
                                                    your OTP is expires in {formatCountdown(remainingTime)}
                                                </small>
                                            </>
                                            <HERBUI.Col className="mt-4" xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                <HERBUI.InputGroup className="mb-4p5">
                                                    <button type="submit" className="btn btn-success"
                                                        disabled={formik?.values?.otp?.length !== 6 || (details !== undefined && details !== "")}
                                                        onClick={() => { setButtonType("Verify OTP"); }}
                                                    >Verify-OTP</button>
                                                    &nbsp;&nbsp;
                                                </HERBUI.InputGroup>
                                            </HERBUI.Col>
                                        </HERBUI.Row>

                                        {
                                            resendTimerShow === 0 &&
                                            <HERBUI.Row>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                    <button className='btn btn-primary' onClick={() => sendOTP()} disabled={resend}>Resend OTP</button>
                                                </HERBUI.Col>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                    <h2 style={{ fontSize: '12px' }}> Available in {timer} min</h2>
                                                </HERBUI.Col>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                </HERBUI.Col>
                                            </HERBUI.Row>
                                        }
                                    </>
                                } */}
                                {/* {otpStatus === false &&
                                    <HERBUI.Row>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                            <HERBUI.Button variant="success" type="submit" className="btn_success btn-sm">
                                                {buttonType}
                                            </HERBUI.Button>
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        </HERBUI.Col>
                                    </HERBUI.Row>
                                } */}
                                <br></br>
                                <br></br>
                                {showDetails &&
                                    <HERBUI.Row >
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>&nbsp;</HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                            <HERBUI.ListGroup>
                                                <HERBUI.ListGroupItem><b>CFMS ID : </b> {details.cfmsid}</HERBUI.ListGroupItem>
                                                {
                                                    details.cfmsid && details.cfmsid?.length !== 10 &&
                                                    <HERBUI.ListGroupItem><b>HRMS ID : </b> {details.hrmsid}</HERBUI.ListGroupItem>
                                                }
                                                <HERBUI.ListGroupItem><b>Name : </b>{details?.name}</HERBUI.ListGroupItem>
                                            </HERBUI.ListGroup>
                                            <span > </span>
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>&nbsp;</HERBUI.Col>
                                    </HERBUI.Row>
                                }
                            </Form>
                        </FormikProvider>
                    </HERBUI.Col>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                        &nbsp;
                    </HERBUI.Col>
                </HERBUI.Row>
            </HERBUI.Container>
            <Footer />
        </>
    )
}